import { GETConfig, POSTConfig } from "@/types/common.types";
import {
	AddReporterParams,
	Reporter,
	UpdateReporterParams,
} from "@/types/reporter.types";
import axios from "axios";

const server_url = process.env.REACT_APP_SERVER_DOMAIN;

export const addReporter = async (
	accessToken: string,
	params: AddReporterParams
) => {
	const response = await axios.post(
		`${server_url}case/addreporters`,
		params,
		POSTConfig(accessToken)
	);

	return response.data;
};

export const updateReporter = async (
	accessToken: string,
	params: UpdateReporterParams
) => {
	const response = await axios.post(
		`${server_url}case/updatereporter`,
		params,
		POSTConfig(accessToken)
	);
	return response.data;
};

export const getReporters = async (
	accessToken: string
): Promise<Reporter[]> => {
	const res = await axios.get(
		`${server_url}case/getreporters`,
		GETConfig(accessToken)
	);
	return res.data;
};

export const getSingleReporter = async (
	reporterid: number,
	accessToken: string
): Promise<Reporter> => {
	const res = await axios.get(
		`${server_url}case/getsinglereporter/${reporterid}`,
		GETConfig(accessToken)
	);
	return res.data[0];
};
